export default {
  visitedPage: 'visitedPage_Sowings',
  clickedButton_createPlanting: 'clickedButton_createPlanting',
  clickedButton_createPlantingNext: 'clickedButton_createPlantingNext',
  clickedButton_createPlantingSave: 'clickedButton_createPlantingSave',
  createPlanting_close: 'createPlanting_close',
}
